import React from 'react';
import { Link } from 'react-router-dom';
import { FaBirthdayCake } from 'react-icons/fa';
import './NotFound.css';
import { useSettings } from '../context/SettingsContext';

export default function NotFound() {
    const SITE_CONFIG = useSettings();

    return (
        <div className="notfound-page">
            <div className="notfound-content">
                <FaBirthdayCake size={48} color="#6B1A1A" style={{ marginBottom: 20 }} />
                <p className="notfound-code">404</p>
                <h1 className="notfound-title">Page Not Found</h1>
                <div className="gold-rule" style={{ maxWidth: 200, margin: '20px auto' }} />
                <p className="notfound-desc">
                    Looks like this slice doesn't exist. The page you're looking for may have
                    been moved, renamed, or never baked in the first place.
                </p>
                <div className="notfound-actions">
                    <Link to="/" className="btn-primary">Back to Home</Link>
                    <Link to="/contact" className="btn-outline">Contact Us</Link>
                </div>
                <p className="notfound-hint">
                    Need help? Reach out on WhatsApp at {SITE_CONFIG.whatsappDisplay}
                </p>
            </div>
        </div>
    );
}